export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-voronoi/src/constant.js
// module id = /NV2
// module chunks = 0